import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { Dropdown, Nav, NavItem, OverlayTrigger, Tooltip } from 'react-bootstrap'
import GlobalSearch from '../GlobalSearch'

const InnerSearchMenuItem = () => {
    const [show, setShow] = useState(false)

    return (
        <Dropdown
            as={NavItem}
            className="no-arrow d-sm-none"
            show={show}
            onToggle={(isOpen) => setShow(isOpen)}
        >
            <OverlayTrigger
                placement="bottom"
                trigger={['hover', 'focus']}
                show={!show ? undefined : false}
                overlay={
                    <Tooltip id="tooltip-search" style={{ margin: 0 }}>
                        Search
                    </Tooltip>
                }
            >
                {({ ref, ...triggerHandler }) => (
                    <Dropdown.Toggle
                        as={Nav.Link}
                        {...triggerHandler}
                        ref={ref}
                    >
                        <FontAwesomeIcon icon={faSearch} />
                    </Dropdown.Toggle>
                )}
            </OverlayTrigger>
            <Dropdown.Menu
                align="end"
                className="dropdown-list dropdown-menu shadow animated--grow-in global-search-dropdown-menu p-0"
                style={{ margin: 0, minWidth: '320px' }}
            >
                <div className="p-2">
                    <GlobalSearch
                        variant="inner"
                        onResultSelect={() => setShow(false)}
                        inputClassName="bg-light border-0 small"
                    />
                </div>
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default InnerSearchMenuItem
